export default function SignatureReceived() {
  return (
    <div className="tw-mt-[120px] tw-w-full tw-text-center">
      <h3>Signature Recorded</h3>
      <p>Thank you! We'll get the order shipped out right away.</p>
      <p>
        If you have other orders that require a signature, you should <br />
        have other emails with signature links for those orders.
      </p>
    </div>
  );
}
